import { rewardRegularReq, rewardReqWithoutLogin } from "@/utils/request";
export function lotteryInit(params) {
    return rewardRegularReq({
        url: "/cook-manage-admin/api/ops/activity/lottery/userInit",
        //url: "/api/ops/activity/lottery/userInit",
        method: "get",
        params
    });
}
export function lotteryTotalPeople(params = {}) {
    return rewardReqWithoutLogin({
        url: "/cook-manage-admin/api/ops/activity/lottery/statisticsCount",
        method: "get",
        params
    });
}
export function shareAfterFun(params) {
    return rewardRegularReq({
        url: "/cook-manage-admin/api/ops/activity/lottery/share",
        method: "get",
        params
    });
}
export function addShareUserNote(params) {
    return rewardReqWithoutLogin({
        url: "/cook-manage-admin/api/ops/activity/lottery/clickShare",
        method: "get",
        params
    });
}
//中国新厨房点击抽奖
export function clickLotteryReward(params) {
    return rewardRegularReq({
        url: "/cook-manage-admin/api/ops/activity/lottery/lottery",
        method: "get",
        params
    });
}
//618活动点击抽奖
export function clickLotteryDrawed(params) {
    return rewardRegularReq({
        url: "/cook-manage-admin/api/ops/activity/lottery/lottery2",
        method: "get",
        params
    });
}
//获取sign
export function getSign(params) {
    return rewardRegularReq({
        url: "/cook-manage-admin/api/ops/activity/lottery/getSign",
        method: "get",
        params
    });
}
export function repeatUseRequestFun(config) {
    return rewardRegularReq(config);
}



// WEBPACK FOOTER //
// ./src/api/lotteryDraw.js